export const UseConstant = () => {

    const constant = {
        IS_FIRST_LOGIN: '1',
        
        //user types
        USER_TYPE_ADMIN: '1',
        USER_TYPE_USER: '2',
        USER_TYPE_EMPLOYEE: '3',

        // 一覧件数
        COUNTRY_LIST: 15,
        BRANCH_LIST: 15,
        DEPARTMENT_LIST: 15,
        ROLE_LIST: 15,
        TECHNOLOGY_LIST: 15,
        RESPONSIBILITY_LIST: 15,
        USER_LIST: 30,
        PROJECT_LIST: 12,

        // USER_TYPES
        USER_TYPES: [
            {key: '1', val: 'システム管理者'},
            {key: '2', val: '管理者'},
            {key: '3', val: 'ユーザ'}
        ],

        // EXPERT_LEVELS
        EXPERT_LEVELS: [
            {key: 1, val: 1},
            {key: 2, val: 2},
            {key: 3, val: 3},
            {key: 4, val: 4},
            {key: 5, val: 5},
        ],

        // COTRACT_TYPES
        CONTRACT_TYPES: [
            {key: '1', val: '正社員'},
            {key: '2', val: '非正社員'}
        ],

        // SEX
        SEX: [
            {key: '1', val: '男性'},
            {key: '2', val: '女性'},
            {key: '3', val: 'その他'},
        ],

        // PROJECT_TYPES
        PROJECT_TYPES: [
            {key: '1', val: '社内'},
            {key: '2', val: '社外'}
        ],

        // YES_NO
        YES_NO: [
            {key: '1', val: 'はい'},
            {key: '0', val: 'いいえ'}
        ],
    };

    return {
        constant
    };
};
